// extracted by mini-css-extract-plugin
module.exports = {"textWrapper":"VideoWin_textWrapper__1S0O_","text":"VideoWin_text__2Bys3","visible":"VideoWin_visible__2-ifK"};